import { useMemo } from 'react'

import { PointReason } from './point-icon'

type PointSubtitleProps = {
  inviterName: string
  inviteeName: string
  text: string
  points: number
  reason: PointReason
  message: string
}

type PointSubtitleTextMapProps = {
  inviterName: string
  inviteeName: string
  text: string
  points: number
  message: string
}

const PointSubtitleTextMap = {
  [PointReason.INVITED]: ({ inviterName, points }: PointSubtitleTextMapProps) =>
    `${inviterName} invited you to join Conrad & you successfully verified. Here are ${points} points!`,
  [PointReason.INVITATION]: ({ inviteeName }: PointSubtitleTextMapProps) => `${inviteeName} accepted your invitation`,
  [PointReason.FIRST_SENT_REFERRAL]: ({ text }: PointSubtitleTextMapProps) => text,
  [PointReason.SENT_REFERRAL_APPROVED]: ({ text }: PointSubtitleTextMapProps) => text,
  [PointReason.RECEIVED_REFERRAL_APPROVED]: ({ text }: PointSubtitleTextMapProps) => text,
  [PointReason.FIRST_POINTS]: ({ points }: PointSubtitleTextMapProps) =>
    `Welcome! You earned ${points} points for joining`,
  [PointReason.LEAD_CREDIT_REWARD]: ({ text }: PointSubtitleTextMapProps) => text,
  [PointReason.SUPPORT]: ({ points }: PointSubtitleTextMapProps) =>
    `You earned ${points} points for supporting the community`,
  [PointReason.GENERAL]: ({ points }: PointSubtitleTextMapProps) => `You earned ${points} points`,
  [PointReason.CUSTOM]: ({ points, message }: PointSubtitleTextMapProps) => `${message} - ${points} points earned`,
  [PointReason.FEED_ACTIVITY]: ({ points }: PointSubtitleTextMapProps) =>
    `You earned ${points} points for your feed activity this week!`,
  [PointReason.PARTNER_MATCH]: ({ text }: PointSubtitleTextMapProps) => text,
  [PointReason.PROFILE_COMPLETED]: ({ text }: PointSubtitleTextMapProps) => text,
}

const PointSubtitle = ({ inviterName, inviteeName, text, points, reason, message }: PointSubtitleProps) => {
  const subtitle = useMemo(() => {
    if (!reason) {
      return null
    }
    if (!PointSubtitleTextMap[reason]) {
      console.warn(`Unknown point reason encountered: ${reason}`)
      return null
    }
    return PointSubtitleTextMap[reason]({ inviterName, inviteeName, text, points, message })
  }, [inviterName, inviteeName, text, points, reason, message])

  if (!subtitle) {
    return null
  }

  return <p className="text-[13px] leading-[18px] text-muted">{subtitle}</p>
}

export default PointSubtitle
